export const SHORTLIST_QUERY_PARAM = 'add-to-shortlist';
export const LISTINGS_TAB_PAGE_PARAM = 'tab-page';
export const LISTINGS_TAB_CATEGORY_PARAM = 'tab';
